var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStopBreak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1992",
    "data-name": "Group 1992",
    transform: "translate(-788 -384)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_720",
    "data-name": "Ellipse 720",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(788 384)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3326",
    "data-name": "Rectangle 3326",
    width: 11,
    height: 11,
    rx: 1,
    transform: "translate(795 391)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopBreak);
export default __webpack_public_path__ + "static/media/stop_break.746061d3306b6123c952a2bdfdf62a84.svg";
export { ForwardRef as ReactComponent };